import { numeralFormatter } from 'ns_libs/formatter';
import { IDealUnitType } from 'views/Deals/types';
import { COST_BASIS_TYPES } from 'views/DealDashboard/BOE/components/SlideoutForm/constants';
import { IOptionAnyValue } from 'bricks/types';
import { IProFormaWizardStep2 } from './types';
import { UNIT_MIX_DEFAULT_NAME } from './constants';
import { ITenant, IUnitMix } from './components/ProFormaWizardStepThree/types';

export const getHardCostsAndTotals = (
    boeHardCostsUnitType: string,
    boeSoftCostsUnitType: string,
    wizardBuiltGrossSF: number,
    stepData: IProFormaWizardStep2 | undefined,
    dealUnits: IDealUnitType | undefined,
) => {
    const hardCostSubdiv = boeHardCostsUnitType === COST_BASIS_TYPES.PER_UNIT ? dealUnits?.value || 0 : wizardBuiltGrossSF;
    const softCostSubdiv = boeSoftCostsUnitType === COST_BASIS_TYPES.PER_UNIT ? dealUnits?.value || 0 : wizardBuiltGrossSF;

    let hardCosts = Number(numeralFormatter((Number(stepData?.totalHardCosts || 0)) / hardCostSubdiv, '0.00'));
    let totalHardCosts = Number(numeralFormatter((Number(stepData?.totalHardCosts || 0)), '0.00'));
    let softCosts = Number(numeralFormatter((Number(stepData?.totalSoftCosts || 0)) / softCostSubdiv, '0.00'));
    let totalSoftCosts = Number(numeralFormatter((Number(stepData?.totalSoftCosts || 0)), '0.00'));

    if (boeHardCostsUnitType === COST_BASIS_TYPES.TOTAL) {
        hardCosts = Number(numeralFormatter((Number(stepData?.totalHardCosts || 0)) / wizardBuiltGrossSF, '0.00'));
        totalHardCosts = Number(numeralFormatter((Number(stepData?.totalHardCosts || 0)), '0.00'));
    }

    if (boeSoftCostsUnitType === COST_BASIS_TYPES.TOTAL) {
        softCosts = Number(numeralFormatter((Number(stepData?.totalSoftCosts || 0)) / wizardBuiltGrossSF, '0.00'));
        totalSoftCosts = Number(numeralFormatter((Number(stepData?.totalSoftCosts || 0)), '0.00'));
    }

    return {
        hardCosts,
        totalHardCosts,
        softCosts,
        totalSoftCosts,
    };
};

export const getNewUnitMixName = (selectedBedrooms: IOptionAnyValue | null, selectedBathrooms: IOptionAnyValue | null) => {
    let newUnitMixName = '';
    if (selectedBedrooms != null || selectedBathrooms != null) {
        const bedroomPart = selectedBedrooms === undefined ? '—'
            : `${selectedBedrooms?.value === 0 ? 'Studio' : `${selectedBedrooms?.value || '—'} BDR`}`;
        const bathroomPart = selectedBathrooms === undefined ? '—' : `${selectedBathrooms?.value || '—'} Bath`;
        newUnitMixName = `${bedroomPart} / ${bathroomPart}`;
    } else {
        newUnitMixName = UNIT_MIX_DEFAULT_NAME;
    }
    return newUnitMixName;
};

export const getWizardOperationsIncomeTotals = (isApartment: boolean, unitArray: IUnitMix[], tenantArray: ITenant[]) => {
    let totalRentalIncome = 0;
    let totalIncomeUnits = 0;
    let totalSFPerUnits = 0;

    if (isApartment) {
        totalRentalIncome = unitArray.reduce((sum, unit) => sum + unit.totalRent!!, 0);
        totalIncomeUnits = unitArray.reduce((sum, unit) => sum + (unit.units || 0), 0);
        totalSFPerUnits = unitArray.reduce((sum, unit) => sum + ((unit.averageSquareFootage || 0) * (unit.units || 0)), 0);
    } else {
        totalRentalIncome = tenantArray.reduce((sum, tenant) => sum + tenant.totalRent!!, 0);
        totalIncomeUnits = tenantArray.length;
        totalSFPerUnits = tenantArray.reduce((sum, tenant) => sum + (tenant.squareFootage || 0), 0);
    }

    return {
        totalRentalIncome,
        totalIncomeUnits,
        totalSFPerUnits,
    };
};
